export default class CurrencyExchangePageController {
    constructor(
        currencyTranslations,
        providers,
        availableCurrencies
    ) {
        this.currencyTranslations = currencyTranslations;
        this.providers = providers;
        this.availableCurrencies = availableCurrencies;
    }
}

CurrencyExchangePageController.$inject = [
    'currencyTranslations',
    'providers',
    'availableCurrencies'
];
